import React from 'react';
export const SpaceContext = React.createContext({
    latestIndex: 0,
});
export const SpaceContextProvider = SpaceContext.Provider;
